<template lang="pug">

.app-card.overflow-x-auto.customers-styled-panel
  //- Header con título e ícono
  .d-flex.align-items-center.justify-content-between.tw-mb-3.tw-pb-2.tw-border-b.tw-border-gray-200
    .d-flex.align-items-center.tw-gap-2
      i.fa-solid.fa-building.tw-text-indigo-600
      span.tw-font-semibold.tw-text-gray-700 {{ $I18n.t('vue.customers_detail_table_panel.title') }}
      span.tw-bg-indigo-100.tw-text-indigo-700.tw-px-2.tw-py-1.tw-rounded-full.tw-text-xs.tw-font-medium {{ items.length }}
    create-customer-modal(
      :data-id='record.id' 
      :data-model='record.model'
    )
  
  //- Tabla mejorada
  .table-responsive(v-if="!emptyItems")
    table.table.table-hover.customers-styled-table
      thead
        tr
          th.tw-text-center(style="width: 40px;") #
          th(style="width: 200px;") {{ $I18n.t('vue.customers_detail_table_panel.table_header_name') }}
          th.tw-text-center(style="width: 80px;") Status
          th(style="width: 150px;")
            i.fa-solid.fa-phone.tw-text-gray-400.tw-text-xs.tw-mr-1
            | Phone
          th.tw-text-center(style="width: 100px;")
            i.fa-solid.fa-store.tw-text-gray-400.tw-text-xs.tw-mr-1
            | Restaurants
          th.tw-text-center(style="width: 80px;")
            i.fa-solid.fa-address-book.tw-text-gray-400.tw-text-xs.tw-mr-1
            | Contacts
          th.tw-text-center(style="width: 100px;") Actions
      tbody
        tr(v-for="(item, index) in items" :key="item.id" :class="getRowClass(item)")
          //- Número
          td.tw-text-center.tw-text-gray-400 {{ index + 1 }}
          //- Name
          td
            .d-flex.align-items-center.tw-gap-2
              .tw-w-9.tw-h-9.tw-rounded-full.d-flex.align-items-center.justify-content-center.tw-flex-shrink-0(:class="item.is_active ? 'tw-bg-indigo-100' : 'tw-bg-gray-200'")
                i.fa-solid.fa-building.tw-text-sm(:class="item.is_active ? 'tw-text-indigo-600' : 'tw-text-gray-400'")
              .d-flex.flex-column
                span.tw-font-medium.tw-text-gray-800(v-if="item.aka") {{ item.aka }}
                span.tw-text-sm(:class="item.aka ? 'tw-text-gray-500' : 'tw-text-gray-800 tw-font-medium'") {{ item.name }}
          //- Status
          td.tw-text-center
            span.tw-px-2.tw-py-1.tw-rounded-full.tw-text-xs.tw-font-medium(
              :class="item.is_active ? 'tw-bg-green-100 tw-text-green-700' : 'tw-bg-red-100 tw-text-red-700'"
            )
              i.tw-mr-1(:class="item.is_active ? 'fa-solid fa-check' : 'fa-solid fa-times'")
              | {{ item.is_active ? 'Active' : 'Inactive' }}
          //- Phone
          td
            .d-flex.align-items-center.tw-gap-1(v-if="item.phone && item.phone.number")
              i.fa-solid.fa-phone.tw-text-blue-400.tw-text-xs
              span.tw-text-sm.tw-font-mono {{ item.phone.number }}
            span.tw-text-gray-400.tw-text-xs(v-else) —
          //- Restaurants count
          td.tw-text-center
            .d-flex.align-items-center.justify-content-center.tw-gap-1(v-if="item.restaurants_count > 0")
              span.tw-px-2.tw-py-1.tw-rounded.tw-text-xs.tw-font-medium.tw-bg-purple-100.tw-text-purple-700
                i.fa-solid.fa-store.tw-mr-1
                | {{ item.active_restaurants_count }}/{{ item.restaurants_count }}
            span.tw-text-gray-400.tw-text-xs(v-else) 0
          //- Contacts count
          td.tw-text-center
            span.tw-px-2.tw-py-1.tw-rounded.tw-text-xs.tw-font-medium(
              v-if="item.contacts_count > 0"
              class="tw-bg-blue-100 tw-text-blue-700"
            )
              i.fa-solid.fa-user.tw-mr-1
              | {{ item.contacts_count }}
            span.tw-text-gray-400.tw-text-xs(v-else) 0
          //- Actions
          td.tw-text-center
            .d-flex.justify-content-center.tw-gap-1
              delete-customer-modal(
                :data-id='item.id'
                @deleted='retrieveCustomers'
              )
              app-icon-link(
                data-kind="link",
                :href="item.paths.show"
                data-icon="fa-solid fa-eye",
                data-label="",
                :data-title="$I18n.t('vue.customers_detail_table_panel.view_customer')"
              )
  
  //- Estado vacío mejorado
  .tw-text-center.tw-py-8(v-if='emptyItems')
    .tw-w-16.tw-h-16.tw-bg-indigo-100.tw-rounded-full.d-flex.align-items-center.justify-content-center.tw-mx-auto.tw-mb-3
      i.fa-solid.fa-building.tw-text-indigo-400.tw-text-2xl
    p.tw-text-gray-500.tw-mb-0 {{ $I18n.t('vue.customers_detail_table_panel.empty_items') }}

</template>

<script>
import CreateCustomerModal from './create-customer-modal.vue';
import DeleteCustomerModal from './delete-customer-modal.vue'
import CoreComponents from "../core";
import { BackendService } from "../../services";

export default {
  props: {
    dataId: String,
    dataModel: String,
    dataItems: String,
  },
  components:{
    'create-customer-modal': CreateCustomerModal,
    'delete-customer-modal': DeleteCustomerModal,
    "app-icon-link": CoreComponents.AppIconLink,
  },
  data: function () {
    return {
      record: {
        id: this.dataId,
        model: this.dataModel,
      },
      items: JSON.parse(this.dataItems),
    };
  },
  computed: {
    emptyItems: function () {
      return this.items.length === 0;
    }
  },
  methods: {
    getRowClass: function(item) {
      if (item && !item.is_active) return "tw-bg-gray-50 tw-opacity-70";
      return "";
    },
    retrieveCustomers: function () {
    }
  }
};
</script>

<style scoped>
.customers-styled-panel {
  padding: 1rem;
  background: white;
  border-radius: 0.375rem;
}

.customers-styled-table {
  font-size: 0.85rem;
  margin-bottom: 0;
}

.customers-styled-table thead th {
  white-space: nowrap;
  vertical-align: middle;
  padding: 0.5rem 0.75rem;
  background-color: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
  font-weight: 600;
  color: #495057;
}

.customers-styled-table tbody td {
  vertical-align: middle;
  padding: 0.5rem 0.6rem;
}

.customers-styled-table tbody tr:hover {
  background-color: rgba(99, 102, 241, 0.05);
}

/* Avatar circular */
.tw-w-9 {
  width: 2.25rem;
}
.tw-h-9 {
  height: 2.25rem;
}
</style>